import React, { Component } from "react";
import {
  FormGroup,
} from "react-bootstrap";
import moment from "moment";
// import { resetUserData } from "../../libs/utils";
import { getGroups, addGroup, oemAdminGetUsers, updateGroupInfo, getRoles } from "../../libs/db-lib";
import LoaderButton from "../../components/LoaderButton";
import { Loading } from "../../components/Loading.tsx";
import CustomTable from "../../components/CustomTable.tsx";
import ReactTable from '../../components/ReactTable';
import ConfirmModal from "../../components/ConfirmModal.tsx";
import SliderModal from "../../components/SliderModal.tsx";
import AlertModal from "../../components/AlertModal.tsx";
import TextInput from "../../components/TextInput.tsx";
import { Text, TextOnly } from '../../components/Text';
import EditGroup from "./EditGroup.js";
import async from "async";

export default class ManageGroups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alertMessage: "",
      showModal: false,
      groupName: "",
      filter: "",
      showDisableModal: false,
      user: props.user,
      groupList: null,
      groupToDisable: "",
      groupNameToDisable: "",
      isLoading: false,
      groupIDBeingEnabled: "",
      showAddGroupModal: false,
      isLoadingAddGroup: false,
      verifyGroupName: false,
      groupToEdit: null,
      editGroupTab: "",
      roleList: null,
      userList: null,
    };
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }
    try {
      // await resetUserData(this);
      async.auto({
        groups: async (cb) => {
          const groups = await getGroups();
          if (groups?.error) {
            cb(groups.error);
          } else {
            cb(null, groups);
          }
        },
        roles: async (cb) => {
          const roles = await getRoles();
          if (roles?.error) {
            cb(roles.error);
          } else {
            cb(null, roles);
          }
        },

        users: async (cb) => {
          const users = await oemAdminGetUsers();
          if (users?.error) {
            cb(users.error);
          } else {
            const userList = users.userList
            cb(null, userList);
          }
        }

      }, (err, results) => {
        if (!err) {
          this.setState({
            groupList: results.groups ?? [],
            filteredList: results.groups ?? [],
            roleList: results.roles ?? [],
            userList: results.users ?? [],
          })
        }
      })
    } catch (e) {
      this.setState({
        alertMessage: e.message,
        showModal: true,
        isLoading: false,
      });
    }
    this.setState({ windowWidth: window.outerWidth });
    window.addEventListener("resize", this.setWindowWidth.bind(this));
  }

  setWindowWidth() {
    setTimeout(this.setStateWidth.bind(this), 20);
  }

  setStateWidth() {
    this.setState({ windowWidth: window.outerWidth });
  }

  validateForm() {
    return this.state.groupName.length > 0;
  }

  activateSerialNumberVerify() {
    this.setState({ verifySerialNumber: true });
  }

  async handleConfirmModal() {
    // Handle disable group
    this.setState({ isLoading: true });
    try {
      await updateGroupInfo(this.state.groupToDisable, this.state.groupNameToDisable, "INACTIVE");
    } catch (e) {
      this.setState({
        showDisableModal: false,
        groupToDisable: "",
        groupNameToDisable: "",
        alertMessage: e.message,
        showModal: true,
        isLoading: false,
      });
    }

    let groups = this.state.groupList;
    let groupIndex = groups.findIndex((g) => {
      return g.groupID === this.state.groupToDisable;
    });
    if (groupIndex !== -1) {
      groups[groupIndex].groupState = "INACTIVE";
    }

    this.setState({
      showDisableModal: false,
      groupToDisable: "",
      groupNameToDisable: "",
      groupList: groups,
      isLoading: false,
    });
  }

  handleCancelModal(e) {
    this.setState({ showDisableModal: false, groupToDisable: "", groupNameToDisable: "" });
  }

  handleDisableButton(groupId) {
    let group = this.state.groupList.find((group) => group.groupID === groupId);
    let groupName = group.groupName;
    this.setState({
      showDisableModal: true,
      groupToDisable: groupId,
      groupNameToDisable: groupName,
    });
  }

  async handleEnableButton(groupId) {
    let group = this.state.groupList.find((group) => group.groupID === groupId);
    let groupName = group.groupName;
    this.setState({
      groupIDBeingEnabled: groupId,
    });
    try {
      await updateGroupInfo(groupId, groupName, "ACTIVE");
    } catch (e) {
      this.setState({
        alertMessage: e.message,
        showModal: true,
        isLoading: false,
      });
    }

    let groups = this.state.groupList;
    let groupIndex = groups.findIndex((g) => {
      return g.groupID === groupId;
    });
    if (groupIndex !== -1) {
      groups[groupIndex].groupState = "ACTIVE";
    }

    this.setState({
      showDisableModal: false,
      groupToDisable: "",
      groupNameToDisable: "",
      groupList: groups,
      groupIDBeingEnabled: "",
    });
  }

  handleOpenEditGroup(groupId, tabStr) {
    // Get the group info for this group
    let group = this.state.groupList?.find((group) => group.groupID === groupId);
    if (group) {
      this.setState({
        groupToEdit: group,
        editGroupTab: tabStr,
        showEditGroupModal: true,
      })
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
    if (event.target.id === "filter") {
      if (event.target.value.length > 0) {
        const filterArr = event.target.value
          ? event.target.value.split(" ").filter((f) => f !== "")
          : [];
        const filterStr = filterArr.reduce((f1, f2) => f1 + "|" + f2);
        const regexStr = new RegExp("(?:" + filterStr + ")", "ig");
        const groupList = this.state.groupList?.filter((g) => {
          return regexStr.test(g.groupName);
        });

        this.setState({
          filteredList: groupList ? groupList : [],
        });
      } else {
        this.setState({
          filteredList: this.state.groupList,
        });
      }
    } else if (event.target.id === "groupName" && !this.state.verifyGroupName) {
      this.setState({
        verifyGroupName: true,
      })
    }
  };

  handleCancel = () => {
    this.setState({ showModal: false });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    this.setState({ isLoadingAddGroup: true });

    let data = this.state;
    let results = await addGroup(data.groupName);
    if (results?.error) {
      this.setState({
        alertMessage: results.error,
        showModal: true,
        isLoading: false,
        isLoadingAddGroup: false,
      });
    } else {
      const groups = this.state.groupList;
      groups.push({
        groupID: results.groupID,
        groupName: this.state.groupName,
        groupState: 'ACTIVE',
        validityCriteria: 'NORMAL',
        activeRoleDescription: 'No Active Role',
        activeRoleName: 'No Active Role',
        groupActiveRole: '0',
      })
      this.setState({
        alertMessage: "Group successfully added. To add roles to this group, click the edit button under ACTIONS.",
        showModal: true,
        groupName: "",
        groupList: groups,
        showAddGroupModal: false,
        isLoadingAddGroup: false,
        verifyGroupName: false,
      })

      // keeping the following in case we decide to redirect instead.

      // this.props.history.push({
      //   pathname: "/manageGroups/editGroup/",
      //   state: { groupID: results.groupID, tab: "editGroup" },
      // });
    }
  };

  handleShowAddGroupModal = () => {
    this.setState({ showAddGroupModal: true });
  }

  handleCancelAddGroup = () => {
    this.setState({ showAddGroupModal: false });
  }

  handleCancelEditGroup = () => {
    this.setState({
      showEditGroupModal: false,
      groupToEdit: false,
      editGroupTab: "",
    })
  }

  render() {
    const columnDefs = [];

    columnDefs.push({
      header: "Name",
      id: "name",
      accessorKey: "name",
      size: 200,
      enableGrow: true,
    });
    columnDefs.push({ header: "Validity Criteria", id: "validityCriteria", accessorKey: "validityCriteria", size: 150 });

    if (this.state.windowWidth > 500) {
      columnDefs.push({
        header: "State",
        id: "state",
        accessorKey: "state",
        className: "flex-center",
        size: 50,
      });
    }

    columnDefs.push({
      header: this.state.windowWidth > 500 ? "Actions" : "",
      id: "actions",
      size: 110,
      className: "flex-center",
      cell: ({row}) => {
        return (
          <div className="l-flex-gap-1">
            {this.state.user.userType === "OEM_ADMIN" ? (
              <button
                className="c-btn-icon-compact"
                onClick={this.handleOpenEditGroup.bind(this, row.original.groupID, "editGroup")}
              >
                <div className="c-btn__inner">
                  <span
                    className="c-btn__icon fal fa-edit"
                    title="Edit Group"
                  />
                </div>
              </button>
            ) : (
              ""
            )}
            <button
              className="c-btn-icon-compact"
              onClick={this.handleOpenEditGroup.bind(this, row.original.groupID, "users")}
            >
              <div className="c-btn__inner">
                <span
                  className="c-btn__icon fal fa-user-cog"
                  title="Manage Group Users"
                />
              </div>
            </button>
            {this.state.user.userType === "OEM_ADMIN" ? (
              <div>
                {row.original.state === "ACTIVE" ? (
                  <button
                    className="c-btn-icon-compact"
                    onClick={this.handleDisableButton.bind(this, row.original.groupID)}
                  >
                    <div className="c-btn__inner">
                      <span
                        className="c-btn__icon fal fa-times-circle"
                        title="Disable Group"
                      />
                    </div>
                  </button>
                ) : (
                  <button
                    className="c-btn-icon-compact"
                    onClick={this.handleEnableButton.bind(this, row.original.groupID)}
                  >
                    <div className="c-btn__inner">
                      {this.state.groupIDBeingEnabled === row.original.groupID ? (
                        <i className="fal fa-spinner-third spinning" />
                      ) : (
                        <span
                          className="c-btn__icon fal fa-check-circle"
                          title="Enable Group"
                        />
                      )}
                    </div>
                  </button>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        );
      },
      sortable: false,
      filterable: false,
    });

    let groups =
      this.state && this.state.filteredList && this.state.filteredList.length > 0
        ? this.state.filteredList.map((group) => {
            return {
              groupID: group.groupID,
              name: group.groupName,
              state: group.groupState,
              validityCriteria: group.validityCriteria,
              validityParams: group.validityParams,
            };
          })
        : [];

    return (
      <div className="home">
        <div className="panel-frame">
          {this.state.groupList ? (
            <>
              <h2 className="c-page-heading">Groups</h2>
              <div
                className={
                  this.state.windowWidth > 400
                    ? "col-lg-10 col-md-11"
                    : "col-lg-10 col-md-11 no-left-padding"
                }
              >
                {this.state.user && this.state.user.userType === "OEM_ADMIN" && (
                  <button
                    className="c-btn u-margin-bottom-large"
                    onClick={this.handleShowAddGroupModal.bind(this)}
                  >
                    <i className="c-btn__icon fal fa-plus"></i>
                    Add Group
                  </button>
                )}
                <div className="auto-auth-table col-sm-12">
                  <div className="u-width-100-percent display-flex">
                    <TextInput
                      controlID="filter"
                      label="Filter"
                      value={this.state.filter}
                      onChange={this.handleChange.bind(this)}
                    />
                  </div>

                  <CustomTable
                    columns={columnDefs}
                    data={groups}
                    className="-highlight u-margin-top-large"
                    paginationTop
                    paginationBottom
                    noDataText="No Groups"
                    defaultSort={[
                      {
                        id: 'name',
                        desc: false,
                      },
                    ]}
                  />

                  {/* <ReactTable
                    tableName={'Groups'}
                    columns={columnDefs}
                    data={groups} 
                    className="-highlight u-margin-top-large"
                    globalFilter={this.state.filter}
                  /> */}


                </div>
              </div>
            </>
          ) : (
            <Loading />
          )}
        </div>

        <AlertModal
          showModal={this.state.showModal}
          message={this.state.alertMessage}
          handleCancel={this.handleCancel.bind(this)}
        />

        <ConfirmModal
          showModal={this.state.showDisableModal}
          handleCancel={this.handleCancelModal.bind(this)}
          handleConfirm={this.handleConfirmModal.bind(this, this.state.groupToDisable)}
          confirmLoadingText="Disabling Group..."
          title="Confirm Disable Group"
          message={`Are you sure you want to disable the group: ${this.state.groupNameToDisable}?`}
        />

        <SliderModal
          showModal={this.state.showAddGroupModal}
          handleCancel={this.handleCancelAddGroup.bind(this)}
          title="Add Group"
          body={
            <div className="l-container-sm u-margin-top-large">
              <form onSubmit={this.handleSubmit}>
                <TextInput
                  controlID="groupName"
                  label="Group Name"
                  value={this.state.groupName}
                  onChange={this.handleChange}
                  autoFocus={true}
                  maxLength={100}
                  errorCondition={this.state.verifyGroupName && this.state.groupName.length === 0}
                  errorMsg="Group Name cannot be blank"
                />

                <FormGroup>
                  <div className="parent-center">
                    <LoaderButton
                      block
                      disabled={!this.validateForm()}
                      type="submit"
                      isLoading={this.state.isLoadingAddGroup}
                      text="Add Group"
                      loadingText="Adding group…"
                    />
                  </div>
                </FormGroup>
              </form>
            </div>
          }
        />

        <SliderModal
          showModal={this.state.showEditGroupModal}
          className="c-modal-slider-90"
          handleCancel={this.handleCancelEditGroup.bind(this)}
          title="Edit Group"
          body={
            <EditGroup
              group={this.state.groupToEdit}
              tab={this.state.editGroupTab}
              user={this.state.user}
              isAuthenticated={this.props.isAuthenticated}
              history={this.props.history}
              roles={this.state.roleList}
              users={this.state.userList}
            />
          }
        />
      </div>
    );
  }
}
